import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core'
import {Router} from "@angular/router";
import {Location} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  standalone: true
})
export class BackButtonComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  class = input('btn btn-primary me-3');
  visible = input(true);
  routeOverride = input<string>();
  steps = input(-1);

  public back(): void {
    if (this.routeOverride()) {
      this.router.navigate([this.routeOverride()]).then();
    } else {
      this.location.back();
    }
  }
}
